class LSGCarousel extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", ()=>{
            this.carouselinit();
            this.setupVideos();
        })
    }
    pauseAllVideos() {
        const videoGrpEls = this.querySelectorAll(`[lsg-video-playing="true"]`);
        videoGrpEls.forEach((videoGrpEl)=>{
            const videoEl = videoGrpEl.querySelector(`video`);
            videoEl.pause();
            videoGrpEl.setAttribute(`lsg-video-playing`, false);
        });
    }

    setupVideos() {
        const videoGrpEls = this.querySelectorAll(`[lsg-video-playing]`);

        videoGrpEls.forEach((videoGrpEl) => {
            const videoEl   = videoGrpEl.querySelector(`video`),
                  btnEl     = videoGrpEl.querySelector(`[lsg-video-play-btn]`);

            btnEl.addEventListener(`click`, (e) => {
                this.pauseAllVideos();
                videoEl.play();
                videoGrpEl.setAttribute(`lsg-video-playing`, true);
            });

            videoEl.addEventListener(`click`, (e) => {
                videoEl.pause();
                videoGrpEl.setAttribute(`lsg-video-playing`, false);
            });
        });
    }

    carouselinit() {
        var prevArrow =
        `
        <button type='button' class='slick-prev pull-left'>
        <svg style="transform: rotate(360deg);" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9L1 5L4 1" stroke="#232323" stroke-width="1.5"/>
        <path d="M1 5H13" stroke="#232323" stroke-width="1.5"/>
        </svg>
        </button>`
        var nextArrow = `<button type='button' class='slick-next pull-right'>
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 9L12 5L9 1" stroke="#232323" stroke-width="1.5"/>
        <path d="M12 5H0" stroke="#232323" stroke-width="1.5"/>
        </svg>
        </button>`

        // Initialize Slick carousel
        const carousel = document.querySelector('.carousel');
        if (carousel) {
            $(carousel).slick({
                dots: true,
                infinite: true,
                arrows: true,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                speed: 500,
                slidesToShow: 5,
                slidesToScroll: 1,
                centerMode: true,
                pauseOnHover: true,

                responsive: [
                {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 4.15
                        }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2.5
                    }
                },
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 1.5,
                        arrows: false
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1.05,
                        arrows: false
                    }
                }
            ]
            });
        }
    }
}

customElements.define(`lsg-carousel`, LSGCarousel);
